import { StateSchema } from 'app/config/storeConfig/types';
import { MapImageConfig } from '../mapConfigSerialization';

export const getImageTransform = (state: StateSchema): MapImageConfig => state.warehouseMapConstructor.mapConfig.image;
